<template>
  <div data-type="button" class="container">
    <button
      type="button"
      class="button social facebook"
      @click.prevent="share('facebook')"
    >
      <span>Facebook</span>
    </button>
    <button
      type="button"
      class="button social telegram"
      @click.prevent="share('telegram')"
    >
      <span>Telegram</span>
    </button>
    <button
      type="button"
      class="button social incontact"
      @click.prevent="share('vk')"
    >
      <span>VK</span>
    </button>
    <button
      type="button"
      class="button social twitter"
      @click.prevent="share('twitter')"
    >
      <span>twitter</span>
    </button>
    <button
      type="button"
      class="button social classmates"
      @click.prevent="share('ok')"
    >
      <span>OK</span>
    </button>
    <slot />
  </div>
</template>

<script>
const options = {
  facebook: 'http://www.facebook.com/sharer/sharer.php?s=100&p%5Btitle%5D=$Title&p%5Bsummary%5D=$Description&p%5Burl%5D=$Link&p%5Bimages%5D%5B0%5D=$Image',
  telegram: 'https://t.me/share/url?url=$Link&text=$Title',
  vk: 'http://vk.com/share.php?url=$Link&title=$Title&description=$Description&image=$Image&noparse=true',
  twitter: 'https://twitter.com/intent/tweet?text=$Title&url=$Link',
  ok: 'https://connect.ok.ru/offer?url=$Link&title=$Title&imageUrl=$Image',
  // viber: 'viber://forward?text=$Title',asd
  // mail: 'http://connect.mail.ru/share?url=$Link&title=$Title&description=$Description&imageurl=$Image'
};

export default {
  name: 'SocialsShare',
  props: {
    url: String,
    title: String,
    description: String,
  },
  methods: {
    share(network) {
      let url = options[network];

      url = url.replace(/\$Link/, encodeURIComponent(this.url) || '');
      url = url.replace(/\$Title/, encodeURIComponent(this.title) || '');
      url = url.replace(/\$Description/, encodeURIComponent(this.description) || '');
      url = url.replace(/\$Image/, encodeURIComponent(this.Image) || '');

      const width = 800, height = 500;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      const socialWindow = window.open(url, 'share_window', `height=${height},width=${width},top=${top},left=${left}`);

      socialWindow.focus();
    },
  },
};
</script>

<style lang="sass" scoped>
  .container
    display: grid
    grid-template-rows: 1fr 1fr
    grid-template-columns: 1fr 1fr 1fr
    grid-gap: 20px

    +respond-to('small')
      display: flex

  button
    max-width: 100%
    height: 50px
    margin: 0
    display: block

    +respond-to('medium')
      width: 60px
</style>
